export const isValidPhoneNumber = (value = "") => /^\d{10}$/.test(value.trim());

export const isValidEmail = (value = "") =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());

export const isAddUserFormValid = (
  { phone, email, name, role },
  {
    existingUserId = null,
    isMappedToOutlet = false,
    lookupStatus = "idle",
  } = {}
) => {
  const normalizedPhone = String(phone || "")
    .replace(/\D/g, "")
    .slice(-10);
  const normalizedEmail = String(email || "").trim();
  const hasValidContact =
    isValidPhoneNumber(normalizedPhone) || isValidEmail(normalizedEmail);
  const optionalPhoneIsValid =
    !String(phone || "").trim() || isValidPhoneNumber(normalizedPhone);
  const optionalEmailIsValid =
    !normalizedEmail || isValidEmail(normalizedEmail);
  const lookupIsComplete =
    lookupStatus === "found" ||
    lookupStatus === "not-found" ||
    lookupStatus === "unavailable";
  const hasUserDetails =
    existingUserId !== null && existingUserId !== undefined
      ? true
      : Boolean(String(name || "").trim());

  return Boolean(
    hasValidContact &&
      optionalPhoneIsValid &&
      optionalEmailIsValid &&
      hasUserDetails &&
      role &&
      lookupIsComplete &&
      !isMappedToOutlet
  );
};
